<template>
    <main class="main-content">

        <img v-if="text === 'paySuccess'" src="/images/gif/Reliable.gif">
        <img v-if="text === 'payError'" src="/images/gif/Error.gif">
        <span class="nfd_text">{{$t(text)}}</span>

        <button v-if="text === 'payLoading' || text === 'payConsideration'" @click="getOperationInfo">Обнавить</button>
        <button v-if="text === 'paySuccess'" @click="getReceipt">Чек pdf</button>

        <router-link to="/" class="nfd_btn">{{$t("toMain")}}</router-link>
    </main>
</template>
<script>
import {mapActions} from 'vuex'
export default {
  data(){
    return {
        preloader: document.querySelector('.preloader'),
        text: '',
        description: '',
        responseType: '',
        external_id: ''
    }
  },
  created() {
    console.log("ssd")
    this.external_id = this.$route.params.id
    if(!this.external_id) {
      console.log("ssd")
      this.$router.push({name: '404'})
    }

    // this.responseType = this.$route.params.type
    this.preloader.classList.contains('d-none') || this.preloader.classList.add('d-none');
    // if(this.responseType === 'success'){
    //   this.text = 'paySuccess'
    // //   this.description = 'clientError'
    // }else{
    //   this.text = 'payError'
    // //   this.description = 'serverError'
    // }
  },
  mounted() {

    this.getOperationInfo();
    
  },
  methods: {
    ...mapActions({
      getReceiptPDF: 'finance/getReceiptPDF',
      getBalanceReceiptPDF: 'finance/getBalanceReceiptPDF',
      getOperationData: 'finance/getOperationData',
      getBalanceOperationData: 'finance/getBalanceOperationData',
    }),
    getTokenWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) return null;

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    },
    async getReceipt() {
      let token = ''
      let payData = {
          type: "ext_id",
          lang: "ru",
          external_id: this.external_id
      }

      token = this.getTokenWithExpiry("wtkn")
      
      

      try {
        let resp
        if(localStorage.getItem("payType") === 'balance'){
          resp = await this.getBalanceReceiptPDF({token, payData});
        }else{
          resp = await this.getReceiptPDF({token, payData});
        }
        
        if(resp.status !== 200){
          toastr.error("Произошло ошибка!");
          return;
        }
        const url = window.URL.createObjectURL(new Blob([resp.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.pdf')
        document.body.appendChild(link)
        link.click()
        link.remove()

      } catch (error) {
        toastr.error("Ошибка auth");
        throw error; 
      }
    },

    async getOperationInfo() {
      let token = ''
      let payData = { }
      if(localStorage.getItem("payType") === 'balance'){
        token = this.getTokenWithExpiry("wtknb")
      }else{
        token = this.getTokenWithExpiry("wtkn")
        payData = {
          type: "ext_id",
          external_id: String(this.external_id)
        }
      }

      try {
        let resp
        let status
        if(localStorage.getItem("payType") === 'balance'){
          resp = await this.getBalanceOperationData({token, payData});
          status = resp[0].status
        }else{
          resp = await this.getOperationData({token, payData});
          status = resp.data.attributes.status
        }
        
        if(status === 19 || status === 11){
          this.text = 'payLoading'
        } else if(status === 12 ) {
          this.text = 'payConsideration'
        } else if(status === 14 ) {
          this.text = 'paySuccess'
        } else if(status === 17 ) {
          this.text = 'payCancelled'
        } else {
          this.text = 'payError'
        }
      } catch (error) {
        toastr.error("Ошибка auth");
        throw error; 
      }
    },
  }
}
</script>
<style scoped>
.main-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #289853;
    font-weight: bold;
    gap: 15px;
    /* background-image: url("/public/images/backgrounds/404.png");
    background-repeat: no-repeat;
    background-position: 50% 25%; */
}
.nfd_text{
    margin: 20px 0 10px 0;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 42px;
    text-align: center;
    letter-spacing: -0.03em;
    color: #343434;
}
.nfd_description{
    width: 360px;
    height: 80px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #808784;
}
.nfd_btn{
    background: linear-gradient(45deg, #10934F 0%, #83C555 100%);
    box-shadow: 0px 8px 40px rgba(18, 148, 79, 0.3);
    border-radius: 12px;
    padding: 12px 24px;
    color: #fff;
}
.nfd_btn:hover{
    background: linear-gradient(45deg, #13B05F 0%, #94DE60 100%);
    transition: all .2s ease-in;
}
@media (max-width: 1200px) { 
    .main-content img{
        max-width: 250%;
        margin-top: 120px;
    }
}
</style>